<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @todoAdd="todoAddFun"
        @todoCheck="todoCheckFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.paymentUnitName"
              placeholder="请输入付款单位名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.receiveUnitName"
              placeholder="请输入收款单位名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.projectNo"
              placeholder="请输入项目编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择单据状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        :total-amount="totalAmount"
        :is-show-total="isShowTotal"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @remove="removeFun(arguments)"
        @check="checkFun(arguments)"
        @unCheck="unCheckFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @getTotal="totalFun"
      />
    </div>

    <!-- 修改 -->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogEditVisible"
      @reloadData="loadTableData()"
    />

    <!-- 新增 修改 - 自定义 -->
    <add-edit-custom-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
    />

    <!-- 复核 -->
    <check-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogCheckVisible"
      @reloadData="loadTableData()"
    />

    <!-- 待办任务清单 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      dialog-title="待创建应收款单的方案"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 修改-方案生成的
import addEditDialog from './components/addEditDialog'
// 新增 修改 - 自定义
import addEditCustomDialog from './components/addEditCustomDialog'
// 查看
import viewDialog from './components/viewDialog'
// 复核
import checkDialog from './components/checkDialog'
// 待办任务清单
import taskListDialog from './components/taskListDialog'
// 数据请求
import { loadReceivableListDataApi, loadReceivableExportDataApi, saveOrUpdateReceivableApi, countReceivableTodoNumberApi } from '@/api/receivable'
import { countTodoApi } from '@/api/materialsScheme'

export default {
  name: 'Receivable',
  components: {
    CustomTable,
    TableOperation,
    addEditDialog,
    addEditCustomDialog,
    viewDialog,
    checkDialog,
    taskListDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'receivable_bill_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['receivable_bill_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['receivable_bill_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['receivable_bill_check'],
            prop: 'checkFun',
            label: '复核',
            method: 'check'
          },
          {
            permissionSigns: ['receivable_bill_uncheck'],
            prop: 'unCheckFun',
            label: '反复核',
            method: 'unCheck'
          },
          {
            permissionSigns: ['receivable_bill_delete'],
            prop: 'removeFun',
            label: '作废',
            method: 'remove'
          },
          {
            permissionSigns: ['receivable_bill_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['receivable_bill_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            paymentUnitName: '',
            receiveUnitName: '',
            projectNo: '',
            status: ''
          }
        }
      },
      // 待办
      todoList: [
        {
          permissionSigns: ['receivable_bill_add'],
          label: '待创建应收款单的方案',
          method: 'todoAdd',
          count: 0
        },
        {
          permissionSigns: ['receivable_bill_check'],
          label: '待复核的应收款单',
          method: 'todoCheck',
          count: 0
        }
      ],
      statusOptions: [{ value: 1, label: '制单' }, { value: 2, label: '复核' }],
      yesOrNoOptions: [{ value: 1, label: '是' }, { value: 0, label: '否' }],
      id: null, // 选中的单据ID
      eventType: '',
      dialogTitle: '',
      totalAmount: 0, // 合计结果
      isShowTotal: false, // 合计显示
      dialogAddEditVisible: false,
      dialogEditVisible: false,
      dialogViewVisible: false,
      dialogCheckVisible: false,
      dialogTaskVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'isRealitySettleStr', label: '是否据实结算', filterColumn: 'r.is_reality_settle', filterValue: 'isRealitySettle', filterArray: this.yesOrNoOptions, width: 140 },
      { prop: 'provinceName', label: '省区', filterColumn: 'r.province_name', width: 90 },
      { prop: 'cityName', label: '市场', filterColumn: 'r.city_name', width: 100 },
      { prop: 'paymentUnitName', label: '付款单位', filterColumn: 'pu.unit_name', width: 180 },
      { prop: 'receiveUnitName', label: '收款单位', filterColumn: 'ru.unit_name', width: 180 },
      { prop: 'receiveBankName', label: '收款银行', filterColumn: 'ru.bank_name', width: 150 },
      { prop: 'receiveBankNo', label: '收款账号', filterColumn: 'ru.bank_no', width: 150 },
      { prop: 'startDateValue', label: '开始时间', filterColumn: 'r.start_date', width: 120, isBetween: true },
      { prop: 'endDateValue', label: '结束时间', filterColumn: 'r.end_date', width: 120, isBetween: true },
      { prop: 'quarter', label: '季度', filterColumn: 'r.quarter', width: 90 },
      { prop: 'projectNo', label: '项目编号', filterColumn: 'r.project_no', width: 200 },
      { prop: 'projectName', label: '项目名称', filterColumn: 'r.project_name', width: 150 },
      { prop: 'schemeTypeValue', label: '项目类型', filterColumn: '(case scheme.scheme_type when 3 then \'终端运维\' when 4 then \'品牌推广\' when 5 then \'其他\' when 6 then \'物料方案\' else \'\' end)', width: 120 },
      { prop: 'schemeAmount', label: '方案金额(不含税)', filterColumn: 'r.scheme_amount', width: 150, allowSum: true, formatPrice: true },
      { prop: 'settleAmount', label: '结算金额(不含税)', filterColumn: 'r.settle_amount', width: 150, allowSum: true, formatPrice: true },
      { prop: 'taxAmount', label: '税额', filterColumn: 'r.tax_amount', width: 100, allowSum: true, formatPrice: true },
      { prop: 'totalAmount', label: '含税金额', filterColumn: 'r.total_amount', width: 110, allowSum: true, formatPrice: true },
      { prop: 'noTaxCheckAmount', label: '中烟结算金额(不含税)', filterColumn: 'r.no_tax_check_amount', width: 180, allowSum: true, formatPrice: true },
      { prop: 'checkAmount', label: '中烟结算金额', filterColumn: 'r.check_amount', width: 130, allowSum: true, formatPrice: true },
      { prop: 'receivedAmount', label: '已收金额', filterColumn: 'r.received_amount', width: 120, allowSum: true, formatPrice: true },
      { prop: 'leftAmount', label: '未收金额', filterColumn: 'r.left_amount', width: 120, allowSum: true, formatPrice: true },
      { prop: 'invoiceAmount', label: '已开票金额', filterColumn: 'r.invoice_amount', width: 120, allowSum: true, formatPrice: true },
      { prop: 'leftInvoiceAmount', label: '未开票金额', filterColumn: 'r.left_invoice_amount', width: 120, allowSum: true, formatPrice: true },
      { prop: 'differenceAmount', label: '调差金额', filterColumn: 'r.difference_amount', width: 120, allowSum: true, formatPrice: true },
      { prop: 'differenceRemark', label: '调差备注', filterColumn: 'rv.difference_remark', width: 120 },
      { prop: 'invoiceNo', label: '发票编号', filterColumn: 'r.invoice_no', width: 150 },
      { prop: 'statusValue', label: '状态', filterColumn: 'r.status', filterValue: 'status', filterArray: this.statusOptions, width: 100 },
      { prop: 'remark', label: '备注', filterColumn: 'rv.remark', width: 180 },
      { prop: 'creator', filterColumn: 'r.creator', label: '制单人', width: 100 },
      { prop: 'createTimeValue', filterColumn: 'r.create_time', label: '制单时间', width: 150, isBetween: true },
      { prop: 'checker', filterColumn: 'r.checker', label: '复核人', width: 100 },
      { prop: 'checkTimeValue', filterColumn: 'r.check_time', label: '复核时间', width: 150, isBetween: true },
      { prop: 'operatorName', filterColumn: 'r.operator_name', label: '操作人', width: 100 },
      { prop: 'operationTimeValue', filterColumn: 'r.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.isShowTotal = false
      this.masterList.tableLoading = true
      loadReceivableListDataApi({ condition: JSON.stringify(this.masterList.tableQuery) }).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data || []
        data.forEach(item => {
          if (item.isRealitySettle === 1) {
            item.fontColor = 'orange'
          }
        })
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      // 待创建应收款单的方案数量
      countTodoApi({ todoReceivable: 'true' }).then(res => {
        this.todoList[0].count = res.data || 0
      })
      // 待复核的应收款单数量
      countReceivableTodoNumberApi({ status: '1' }).then(res => {
        this.todoList[1].count = res.data || 0
      })
    },
    // 合计方法
    totalFun (fieldColumn, computedTotalObj) {
      this.masterList.tableLoading = true
      let sumCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      sumCondition.isSumTotal = true
      sumCondition.sumField = computedTotalObj.filterColumn
      loadReceivableListDataApi(sumCondition).then(response => {
        this.masterList.tableLoading = false
        this.isShowTotal = true
        this.totalAmount = response.data ? response.data.sumTotal : 0
      }).catch()
    },
    // 待创建应收款单的方案清单
    todoAddFun () {
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 待复核的应收款单数据清单
    todoCheckFun () {
      this.masterList.tableQuery.search = {
        paymentUnitName: '',
        receiveUnitName: '',
        projectNo: '',
        status: 1
      }
      this.loadTableData()
    },
    //新增
    addFun () {
      this.eventType = 'add'
      this.dialogTitle = '新增应收款单'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要修改的应收款单', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        this.$message({ message: '应收款单不在制单状态，不能修改', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogTitle = '修改应收款单'
      if (args[0].sourceType === 1) {
        this.dialogEditVisible = !this.dialogEditVisible
      } else {
        this.dialogAddEditVisible = !this.dialogAddEditVisible
      }
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要查看的应收款单', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogTitle = '查看应收款单'
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 作废
    removeFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要作废的应收款单', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        this.$message({ message: '应收款单不在制单状态，不能作废', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定作废该应收款单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdateReceivableApi({ id: args[0].id, isDelete: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 复核
    checkFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要复核的应收款单', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        this.$message({ message: '应收款单不在制单状态，不能复核', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.dialogTitle = '复核应收款单'
      this.dialogCheckVisible = !this.dialogCheckVisible
    },
    // 反复核
    unCheckFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要反复核的应收款单', type: 'warning' })
        return
      } else if (args[0].status === 1) {
        this.$message({ message: '数据不在复核状态，不能反复核', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定反复核该应收款单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdateReceivableApi({ id: args[0].id, isUnCheck: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      loadReceivableExportDataApi({ condition: JSON.stringify(this.exportObj) }).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
